@for (item of availableFilterItems(); track item.label) {
  <ftr-search-type-filter-item
    [icon]="item.icon"
    [label]="item.label"
    [numberOfResults]="item.numberOfResults"
    [selected]="item.selected"
    (onFilterItemSelected)="onFilterItemSelected.emit(item.type)"
    tabindex="0"
  ></ftr-search-type-filter-item>
}
